import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=d854e3d0&scoped=true";
import script from "./Detail.vue?vue&type=script&lang=js";
export * from "./Detail.vue?vue&type=script&lang=js";
import style0 from "./Detail.vue?vue&type=style&index=0&id=d854e3d0&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "d854e3d0", null);
export default component.exports;